import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Profile from "./pages/Profile";
import Login from "./pages/Login";
import getStorage from "./context/auth";
import { tokensKey } from "./util/Constants";
import './antd-overrides.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!getStorage().getItem(tokensKey));
  const hasSession = () => isLoggedIn && !!getStorage().getItem(tokensKey);

  // Function to update login state dynamically
  const updateLoginState = () => {
    setIsLoggedIn(!!getStorage().getItem(tokensKey));
  };

  // Listen for changes in the storage (e.g., after login/logout)
  useEffect(() => {
    window.addEventListener("storage", updateLoginState);
    return () => {
      window.removeEventListener("storage", updateLoginState);
    };
  }, []);

  return (
    <Router>
      <Switch>
        {/* Root: redirect based on login status */}
        <Route
          exact
          path="/"
          render={() => (hasSession() ? <Redirect to="/profile" /> : <Redirect to="/login" />)}
        />

        {/* Login route: if already logged in, redirect to profile */}
        <Route
          path="/login"
          render={(props) =>
            hasSession() ? (
              <Redirect to="/profile" />
            ) : (
              <Login {...props} onLoginSuccess={updateLoginState} />
            )
          }
        />

        {/* Profile route: if not logged in, redirect to login */}
        <Route
          path="/profile"
          render={(props) =>
            hasSession() ? (
              <Profile {...props} updateLoginState={updateLoginState} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />

        {/* Fallback: redirect any unknown route to the root */}
        <Route render={() => <Redirect to="/" />} />
      </Switch>
    </Router>
  );
}

export default App;
